var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2C2.16421 2 2.5 2.28782 2.5 2.64286V8H3.24996L3.25 3.00019C3.25 2.58597 3.58579 2.25019 4.00001 2.25019C4.41422 2.25019 4.75 2.58598 4.75 3.0002L4.74996 8H5.5V2.64286C5.5 2.28782 5.83579 2 6.25 2C6.66421 2 7 2.28782 7 2.64286V8C7 9.3979 6.04389 10.5725 4.74994 10.9055L4.74986 21.25C4.74986 21.6642 4.41407 22 3.99986 22C3.58564 22 3.24986 21.6642 3.24986 21.25L3.24994 10.9055C1.95605 10.5724 1 9.39786 1 8V2.64286C1 2.28782 1.33579 2 1.75 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.75C12.6528 7.75 10.75 9.65279 10.75 12C10.75 14.3472 12.6528 16.25 15 16.25C17.3472 16.25 19.25 14.3472 19.25 12C19.25 9.65279 17.3472 7.75 15 7.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12C23 16.4183 19.4183 20 15 20C10.5817 20 7 16.4183 7 12C7 7.58172 10.5817 4 15 4C19.4183 4 23 7.58172 23 12ZM9.25 12C9.25 15.1756 11.8244 17.75 15 17.75C18.1756 17.75 20.75 15.1756 20.75 12C20.75 8.82436 18.1756 6.25 15 6.25C11.8244 6.25 9.25 8.82436 9.25 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.446a435c7f3695ae71d3063bb934a8df.svg";
export { ForwardRef as ReactComponent };